// PPG の場合はプラン詳細を必ず通るため「詳細・予約」
export const RESERVE_LABEL = import.meta.env.VITE_MODE === 'ppg' ? '詳細・予約' : '予約'
